 <template>
 <div class="left common-store-lefttab">
	<div class="normal">
		<el-menu :default-active="$route.path" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose" :collapse="isCollapse" @select="selectTab">
			<div class="top">
				<div class="title">财务管理中心</div>
				<div class="changebtns" :class="{'right':isCollapse}" @click="toogleColls"></div>
			</div>
			<el-menu-item-group :index="index" v-for="(i,index) in curLimtList" :key="index+'-bparent'">
				<span slot="title" v-if="i.length > 0">{{'0'+(index+1)+itemList[i[0].parent - 1]}}</span>
				<el-menu-item v-for="(m,index) in i" :key="index+'-bchild'" :index="m.id"><router-link :to="m.path">{{m.name}}</router-link></el-menu-item>
			</el-menu-item-group>
		</el-menu>
	</div>
 </div>
</template>
<script type="text/javascript">
	export default {
		props:['myCollapse'],
		data() {
			return {
				isCollapse: false,
				show: true,
				imgSrc: '../../assets/images/store/btn_leftmenu_packup.png',
				itemList:[
          ' 报表管理',
					' 订单与服务'
				],
				list:[
					[{
						path:'/financeManageCenter/cashConcession',
						name:'收银员让利',
						id:'1-1',
						parent:'1'
					},{
						path:'/financeManageCenter/staffSale',
						name:'员工商品销售明细表',
						id:'1-2',
						parent:'1'
					},{
						path:'/financeManageCenter/sfaffService',
						name:'员工服务消耗明细表',
						id:'1-3',
						parent:'1'

					},{
						path:'/financeManageCenter/todoorForm',
						name:'上门费明细表',
						id:'1-5',
						parent:'1'
					},{
						path:'/financeManageCenter/manualcostForm',
						name:'手工费明细表',
						id:'1-6',
						parent:'1'
					},{
						path:'/financeManageCenter/memServiceForm',
						name:'会员服务明细表',
						id:'1-7',
						parent:'1'
					},{
						path:'/financeManageCenter/royaltyPersonSum',
						name:'提成费用汇总（个人）',
						id:'1-8',
						parent:'1'
					},{
						path:'/financeManageCenter/royaltyTeamSum',
						name:'提成费用汇总（团队）',
						id:'1-9',
						parent:'1'
					},{
					// 	path:'/financeManageCenter/cashFlow',
					// 	name:'对账总计',
					// 	id:'1-4',
					// 	parent:'1'
					// },{
						path:'/financeManageCenter/returnMoneyList',
						name:'销售退款明细表',
						id:'1-10',
						parent:'1'
					},{
						path:'/financeManageCenter/returnRechargeList',
						name:'充值退款明细表',
						id:'1-11',
						parent:'1'
					},
					// {
					// 	path:'/financeManageCenter/accountStatiste',
					// 	name:'对账统计',
					// 	id:'1-12',
					// 	parent:'1'
					// }
          ],
          [{
						path:'/financeManageCenter/order',
						name:'订单管理',
						id:'2-1',
						parent:'2'
					},
					{
						path:'/financeManageCenter/serviceList',
						name:'服务单管理',
						id:'2-2',
						parent:'2'
					}
					// ,
					// {
					// 	path:'/financeManageCenter/returnList',
					// 	name:'退货单管理',
					// 	id:'2-3',
					// 	parent:'2'
					// }
					,
					{
						path:'/financeManageCenter/memRecharge',
						name:'会员充值明细',
						id:'2-4',
						parent:'2'
					}
					],
				],
				curLimtList:[]
			}
		},
		created() {
			this.isCollapse = this.myCollapse;
			if(this.$route.meta.isCollapse){
				this.isCollapse = true;
			}

			this.curLimtList = [];
			this.computedList();
		},
		watch: {
    		'$route.meta.isCollapse'(val) {
				if(val){
					this.isCollapse = true;
				}else{
					this.isCollapse = false;
				}
			},
			$route(to) {
				if(to.redirectedFrom === '/financeManageCenter'){
					this.curLimtList = [];
					this.computedList();
				}
			},
			'$store.state.resourceList'(){
				this.curLimtList = [];
				this.computedList();
			}
		},
		mounted () {
			// 刷新时以当前路由做为tab加入tabs
			if (JSON.stringify(this.options).indexOf(this.$route.path) == -1) {
				this.$store.commit('add_tabs', {route: this.$route.path , name: this.$route.name });
			}
			this.$store.commit('set_active_index', this.$route.path.split('/')[2]);
		},
		computed:{
			options () {
				return this.$store.state.options;
			}
		},
		methods: {
			computedList(){
				let resName = [];
				for(let i of this.$store.state.resourceList){
					resName.push(i.url);
				}
				let allList=[],allListPath = [];
				this.list.forEach((m,index)=>{
					let curList = [];
					for(let n of m){
						allListPath.push(n.path);
						if(resName.indexOf(n.path) !== -1){
							// 1-3 员工服务消耗业绩只有婷美有
							if(n.id === '1-3' && this.$store.state.userInfo.brandId != 1){
								continue;
							}
							curList.push(n);
						}
					}
					if(curList.length > 0){
						allList.push(curList);
					}
				})
				this.curLimtList = [];
				this.curLimtList = allList;

				let allPath=[];
				for(let m of this.curLimtList){
					for(let n of m){
						allPath.push(n.path);
					}
				}

				this.$nextTick(() => {
					if(allPath.indexOf(this.$route.path)!== -1 || allListPath.indexOf(this.$route.path) === -1){
						return;
					}else{
						this.$router.push(this.curLimtList[0][0].path);
					}
				})
			},
			handleOpen(key, keyPath) {
				console.log(key, keyPath);
			},
			handleClose(key, keyPath) {
				console.log(key, keyPath);
			},
			toogleColls(){
				if(this.isCollapse){
					this.isCollapse = false;
				}else{
					this.isCollapse = true;
				}
			},
			selectTab(){
				this.$emit('tabFlag', false)
			}
		}
	}
</script>
<style type="text/css">
	@import "../../assets/css/left.css";
</style>



// WEBPACK FOOTER //
// src/components/common/financeLeft.vue